// Environment Configuration
const isProduction = true //process.env.REACT_APP_MODE === "production";
export const Config = {
  apiUrl: isProduction
    ? "https://care.nolimit.id"
    : // "http://4674ddb3.ngrok.io",
      "https://localhost:12010",
  // "http://localhost:9095",

  graphqlUrl: isProduction
    ? "https://care.nolimit.id/graphql"
    : // : "http://localhost:9095/graphql",
    "https://localhost:12010/graphql",
  // "https://4674ddb3.ngrok.io/graphql",
  socketUrl: isProduction
    ? "wss://ws.care.nolimit.id/graphql"
    : "wss://localhost:12010/graphql",
  // : "ws://localhost:9095/graphql",
  // "wss://4674ddb3.ngrok.io/graphql",
  analyticGraphqlUrl: 'https://analytic.care.nolimit.id/graphql'
};

// Available Channels
export const Channels = [
  {
    name: "twitter",
    icon: "twitter-full"
  },
  {
    name: "facebook",
    icon: "facebook-full"
  },
  {
    name: "instagram",
    icon: "instagram-full"
  },
  {
    name: "line",
    icon: "line-full"
  },
  {
    name: "whatsapp",
    icon: "whatsapp-full"
  },
  {
    name: "livechat",
    icon: "livechat-full"
  }
];

// Notice texts
export const Notices = {
  // generic server error
  server: {
    type: "error",
    message: "Server Error"
  },
  "server-error-retry-later": {
    type: 'error',
    message: "Error on loading data. Please try again later."
  },
  // Login module - login page & trial page
  "login-error": {
    type: "error",
    message: "Error on login. Please check company, username, and password."
  },
  "trial-success": {
    type: "success",
    message: "Trial account has been received"
  },
  "trial-empty": {
    type: "error",
    message: "Error on register. Please complete the field."
  },
  // SideMenu module - logout & online status
  "logout-error": {
    type: "error",
    message: "Error attempting to logout"
  },
  "online-status-update-success": {
    type: "success",
    message: "Online status updated"
  },
  "online-status-update-error": {
    type: "error",
    message: "Error updating online status"
  },
  // Case Management module - replying
  "reply-success": {
    type: "success",
    message: "Reply success"
  },
  "reply-error": {
    type: "error",
    message: "Error replying"
  },
  "reply-label-missing-error": {
    type: "error",
    message: "Label is mandatory when replying"
  },
  "reply-message-error": {
    type: "error",
    message: "Error replying because message is empty"
  },
  // Case Management module - escalate reply
  "escalate-success": {
    type: "success",
    message: "Reply escalation success"
  },
  "escalate-error": {
    type: "error",
    message: "Error escalating reply"
  },
  // Case Management module - pending message management
  "pending-update-success": {
    type: "success",
    message: "Pending message updated"
  },
  "pending-update-error": {
    type: "error",
    message: "Error updating pending message"
  },
  "pending-approve-success": {
    type: "success",
    message: "Pending message approved"
  },
  "pending-approve-error": {
    type: "error",
    message: "Error approving pending message"
  },
  "pending-reject-success": {
    type: "success",
    message: "Pending message rejected"
  },
  "pending-reject-error": {
    type: "error",
    message: "Error rejecting pending message"
  },
  "pending-delete-success": {
    type: "success",
    message: "Pending message deleted"
  },
  "pending-delete-error": {
    type: "error",
    message: "Error deleting pending message"
  },
  // Agent Management module
  "profile-update-success": {
    type: "success",
    message: "Profile updated"
  },
  "profile-update-error": {
    type: "error",
    message: "Error updating profile"
  },
  // Case Management module - case assignment and closing
  "case-assign-me-success": {
    type: "success",
    message: "Case assigned successfully"
  },
  "case-assign-me-error": {
    type: "error",
    message: "Error assigning case to myself"
  },
  "case-assign-other-success": {
    type: "success",
    message: "Case assigned successfully"
  },
  "case-assign-other-error": {
    type: "error",
    message: "Error assigning case to other agent"
  },
  "case-unassign-success": {
    type: "success",
    message: "Case unassigned successfully"
  },
  "case-unassign-error": {
    type: "error",
    message:
      "Error unassigning case. Please check if there is any pending message left"
  },
  "case-close-success": {
    type: "success",
    message: "Case closed successfully"
  },
  "case-close-error": {
    type: "error",
    message:
      "Error closing case. Please check if there is any pending message left"
  },
  // Case Management module - info panel note
  "note-save-success": {
    type: "success",
    message: "Note saved"
  },
  "note-save-error": {
    type: "error",
    message: "Error saving note"
  },
  // Case Management module - customer field
  "customer-field-add-error": {
    type: "error",
    message: "Error adding customer field"
  },
  "customer-field-delete-error": {
    type: "error",
    message: "Error deleting customer field"
  },
  "customer-field-update-success": {
    type: "success",
    message: "Customer field updated"
  },
  "customer-field-update-error": {
    type: "error",
    message: "Error updating customer field"
  },
  // label edit
  "label-add-success": {
    type: "success",
    message: "Label added succesfully"
  },
  "label-add-error": {
    type: "error",
    message: "Error adding label"
  },
  "label-delete-success": {
    type: "success",
    message: "Label deleted succesfully"
  },
  "label-delete-error": {
    type: "error",
    message: "Error deleting label"
  },
  // Supervisor module - customer field template
  "customer-field-template-add-success": {
    type: "success",
    message: "Customer field template added"
  },
  "customer-field-template-add-error": {
    type: "error",
    message: "Error adding customer field template"
  },
  "customer-field-template-incomplete-field-error": {
    type: "error",
    message: "Please fill all fields"
  },
  "customer-field-template-update-success": {
    type: "success",
    message: "Customer field template updated"
  },
  "customer-field-template-update-error": {
    type: "error",
    message: "Error updating customer field template"
  },
  "customer-field-template-delete-success": {
    type: "success",
    message: "Customer field template deleted"
  },
  "customer-field-template-delete-error": {
    type: "error",
    message: "Error deleting customer field template"
  },
  // Supervisor module - label template
  "label-template-sort-success": {
    type: "success",
    message: "Label template sorted"
  },
  "label-template-sort-error": {
    type: "success",
    message: "Error sorting label template"
  },
  "label-template-toggle-show-success": {
    type: "success",
    message: "Label template set to show"
  },
  "label-template-toggle-hide-success": {
    type: "success",
    message: "Label template set to hide"
  },
  "label-template-toggle-error": {
    type: "success",
    message: "Error toggling label template"
  },
  "label-template-color-success": {
    type: "success",
    message: "Label template changed color"
  },
  "label-template-color-error": {
    type: "success",
    message: "Error changing label template color"
  },
  "label-template-add-success": {
    type: "success",
    message: "Label template added successfully"
  },
  "label-template-add-error": {
    type: "error",
    message: "Error adding label template"
  },
  "label-template-delete-success": {
    type: "success",
    message: "Label template deleted successfully"
  },
  "label-template-delete-error": {
    type: "error",
    message: "Error deleting label template"
  },
  "label-template-incomplete-field-error": {
    type: "error",
    message: "Please fill all fields"
  },
  // Supervisor module - channel
  "channel-delete-success": {
    type: "success",
    message: "Channel deleted succesfully"
  },
  "channel-delete-error": {
    type: "error",
    message: "Error deleting channel"
  },
  "channel-add-success": {
    type: "success",
    message: "Add channel success"
  },
  "channel-add-error": {
    type: "error",
    message: "Add channel error"
  },
  "channel-color-success": {
    type: "success",
    message: "Label color added successfully"
  },
  "channel-color-error": {
    type: "error",
    message: "Error changing label color"
  },
  "channel-color-success": {
    type: "success",
    message: "Channel color added successfully"
  },
  "channel-color-error": {
    type: "error",
    message: "Error changing channel color"
  },
  "channel-nickname-success": {
    type: "success",
    message: "Channel signature added successfully"
  },
  "channel-nickname-error": {
    type: "error",
    message: "Error changing channel signature "
  },
  // Supervisor module - team
  "team-agent-add-success": {
    type: "success",
    message: "Agent added succesfully"
  },
  "team-agent-add-error": {
    type: "error",
    message: "Error adding agent"
  },
  "team-agent-delete-success": {
    type: "success",
    message: "Agent deleted succesfully"
  },
  "team-agent-delete-error": {
    type: "error",
    message: "Error deleting agent"
  },
  "team-agent-incomplete-field-error": {
    type: "error",
    message: "Please fill all fields"
  },
  // Supervisor module - company config
  "config-update-success": {
    type: "success",
    message: "Company configuration updated"
  },
  "config-update-error": {
    type: "error",
    message: "Error updating company configuration"
  },
  "generic-incomplete-field-error": {
    type: "error",
    message: "Please fill all fields"
  },
  // Supervisor module - auto distribution
  "auto-distributions-add-success": {
    type: "success",
    message: "Auto distribution added succesfully"
  },
  "auto-distributions-add-error": {
    type: "error",
    message: "Error adding auto distribution"
  },
  "auto-distributions-delete-success": {
    type: "success",
    message: "Auto distribution deleted succesfully"
  },
  "auto-distributions-delete-error": {
    type: "error",
    message: "Error deleting Auto distribution"
  },
  "auto-distributions-incomplete-field-error": {
    type: "error",
    message: "Please fill all fields"
  },
  // Supervisor module - template reply
  "template-reply-add-success": {
    type: "success",
    message: "Template reply added succesfully"
  },
  "template-reply-add-error": {
    type: "error",
    message: "Error adding template reply"
  },
  "template-reply-delete-success": {
    type: "success",
    message: "Template reply deleted succesfully"
  },
  "template-reply-delete-error": {
    type: "error",
    message: "Error deleting template reply"
  },
  "template-reply-incomplete-field-error": {
    type: "error",
    message: "Please fill all fields"
  },
  "template-reply-update-success": {
    type: "success",
    message: "Template reply updated succesfully"
  },
  "template-reply-update-error": {
    type: "error",
    message: "Error updated template reply"
  },
  // Analytic module - download success
  "download-report-error": {
    type: "error",
    message: "Please fill email fields"
  },
  "download-report-success": {
    type: "success",
    message: "Report on the way"
  },
  // scheduled post
  "scheduled-post-delete-success": {
    type: "success",
    message: "Scheduled post deleted successfully"
  },
  "scheduled-post-delete-error": {
    type: "error",
    message: "Error deleting scheduled post"
  },
  "scheduled-post-add-success": {
    type: "success",
    message: "Scheduled post add successfully"
  },
  "scheduled-post-add-error": {
    type: "error",
    message: "Scheduled post add error"
  },
  // Setup Account
  "setup-account-success": {
    type: "success",
    message: "Setup account successfully"
  },
  "setup-account-error": {
    type: "error",
    message: "Setup account error"
  },
  "register-form-error": {
    type: "error",
    message: "Please check all field again"
  },
  "register-password-error": {
    type: "error",
    message: "Password and Re-password is not same"
  },
  "connect-account-error": {
    type: "error",
    message: "You are required to connect at least one account"
  },
  "whatsapp-registration": {
    type: "success",
    message: "Please Insert Confirmation Code"
  },
  "whatsapp-registration-error": {
    type: "error",
    message: "Whatsapp Registration Error"
  },
  "whatsapp-registration-code": {
    type: "success",
    message: "Whatsapp Registration Success"
  },
  "whatsapp-registration-code-error": {
    type: "errpr",
    message: "Whatsapp Registration Error"
  },
  "invoke-whatsapp-error": {
    type: "error",
    message: "Followup with Whatsapp Error"
  },
  "download-livechat-html-success": {
    type: "success",
    message: "Download Livechat Html Sucess"
  },
  "download-livechat-html-error": {
    type: "error",
    message: "Download Livechat Html Error"
  },
  "validate-html-success": {
    type: "success",
    message: "Validate Html Success"
  },
  "validate-html-error": {
    type: "error",
    message: "Validate Html Error"
  },
  "create-livechat-template-success": {
    type: "success",
    message: "Create Template Livechat Success"
  },
  "create-livechat-template-error": {
    type: "error",
    message: "Create Template Livechat Error"
  },
  "upload-contact-success": {
    type: 'success',
    message: 'Upload Contact Success'
  },
  "upload-contact-error": {
    type: 'error',
    message: 'Upload Contact Error'
  }
};

// Icon and images
export const Graphics = {
  "agent-off": require("svg/agent-off.svg"),
  "price-tag": require("svg/price-tag.svg"),
  "agent-selected": require("svg/agent-selected.svg"),
  "arrow-down": require("svg/arrow-down.svg"),
  "arrow-down-white": require("svg/arrow-down-white.svg"),
  "arrow-up": require("svg/arrow-up.svg"),
  ascending: require("svg/ascending.svg"),
  bar: require("svg/bar.svg"),
  "clock-blue": require("svg/clock-blue.svg"),
  "clock-red": require("svg/clock-red.svg"),
  "clock-gray": require("svg/clock-gray.svg"),
  descending: require("svg/descending.svg"),
  edit: require("svg/edit.svg"),
  "error-screen": require("svg/karakter-404.svg"),
  facebook: require("svg/fb-polos.svg"),
  "facebook-full": require("svg/fb-full.svg"),
  line: require("svg/line-polos.svg"),
  "line-full": require("svg/line-full.svg"),
  whatsapp: require("svg/whatsapp-polos.svg"),
  "whatsapp-full": require("svg/whatsapp-full.svg"),
  notification: require("svg/notification.svg"),
  search: require("svg/search.svg"),
  filter: require("svg/filter.svg"),
  "more-label": require("svg/more-label.svg"),
  "image-off": require("svg/image-off.svg"),
  "image-off-gray": require("svg/image-off-gray.svg"),
  "image-selected": require("svg/image-selected.svg"),
  "calendar-off": require("svg/calendar-off.svg"),
  "calendar-selected": require("svg/calendar-selected.svg"),
  "info-off": require("svg/info-off.svg"),
  "info-selected": require("svg/info-selected.svg"),
  information: require("svg/information.svg"),
  instagram: require("svg/instagram-polos.svg"),
  "instagram-full": require("svg/instagram-full.svg"),
  loading: require("svg/loading.svg"),
  "loading-dots": require("svg/loading-dots.svg"),
  logo: require("svg/logo.svg"),
  "mail-off": require("svg/mail-off.svg"),
  "mail-selected": require("svg/mail-selected.svg"),
  minus: require("svg/minus.svg"),
  "no-need": require("svg/no-need.svg"),
  plus: require("svg/plus.svg"),
  "recycle-bin": require("svg/recycle-bin.svg"),
  refresh: require("svg/refresh.svg"),
  score: require("svg/score.svg"),

  "sidebar-sms": require("svg/sidebar-sms.svg"),
  "sidebar-sms-selected": require("svg/sidebar-sms-selected.svg"),

  "sidebar-email": require("svg/sidebar-email.svg"),
  "sidebar-email-selected": require("svg/sidebar-email-selected.svg"),


  "sidebar-history": require("svg/sidebar-case-history.svg"),
  "sidebar-history-selected": require("svg/sidebar-case-history-selected.svg"),
  "sidebar-case": require("svg/sidebar-case.svg"),
  "sidebar-case-selected": require("svg/sidebar-case-selected.svg"),
  "sidebar-customer-management": require("svg/sidebar-customer-management.svg"),
  "sidebar-customer-management-selected": require("svg/sidebar-customer-management-selected.svg"),
  "sidebar-logout": require("svg/sidebar-logout.svg"),
  "sidebar-logout-selected": require("svg/sidebar-logout-selected.svg"),
  "sidebar-schedule": require("svg/sidebar-schedule.svg"),
  "sidebar-schedule-selected": require("svg/sidebar-schedule-selected.svg"),
  "sidebar-supervisor": require("svg/sidebar-supervisor.svg"),
  "sidebar-supervisor-selected": require("svg/sidebar-supervisor-selected.svg"),
  "sidebar-team-management": require("svg/sidebar-team-management.svg"),
  "sidebar-team-management-selected": require("svg/sidebar-team-management-selected.svg"),
  "sidebar-analytic": require("svg/sidebar-analytic.svg"),
  "sidebar-analytic-selected": require("svg/sidebar-analytic-selected.svg"),
  "sidebar-agent": require("svg/sidebar-agent-management.svg"),
  "sidebar-agent-selected": require("svg/sidebar-agent-management-selected.svg"),
  twitter: require("svg/twitter-polos.svg"),
  "twitter-full": require("svg/twitter-full.svg"),
  "x-button-blue": require("svg/x-button-blue.svg"),
  "x-button-gray": require("svg/x-button-grey.svg"),
  "x-button": require("svg/x-button-polos.svg"),
  alert: require("svg/x-button.svg"),
  "alert-error": require("svg/alert_error.svg"),
  "alert-info": require("svg/alert_info.svg"),
  "alert-success": require("svg/alert_success.svg"),
  "alert-warning": require("svg/alert_warning.svg"),
  empty: require("svg/empty.svg"),
  template: require("svg/template-answer.svg"),
  "template-selected": require("svg/template-answer-select.svg"),
  livechat: require("svg/livechat-polos.svg"),
  "livechat-full": require("svg/livechat-full.svg")
};

export const whatsappRegistrationList = [
  {
    country: "indonesia",
    mcc: "510",
    cc: "62",
    listProvider: [
      {
        provider: "psn",
        mnc: "00"
      },
      {
        provider: "indosatooredoo",
        mnc: "01"
      },
      {
        provider: "starone",
        mnc: "03"
      },
      {
        provider: "telkomflexi",
        mnc: "07"
      },
      {
        provider: "axis",
        mnc: "08"
      },
      {
        provider: "smartfren",
        mnc: "09"
      },
      {
        provider: "telkomsel",
        mnc: "10"
      },
      {
        provider: "xl",
        mnc: "11"
      },
      {
        provider: "telkommobile",
        mnc: "20"
      },
      {
        provider: "im3",
        mnc: "21"
      },
      {
        provider: "net1",
        mnc: "27"
      },
      {
        provider: "fren",
        mnc: "28"
      },
      {
        provider: "bolt!super4G",
        mnc: "88"
      },
      {
        provider: "3",
        mnc: "89"
      },
      {
        provider: "esia",
        mnc: "99"
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/constant.js